import * as XLSX from 'xlsx';
 
export const ProductExport = (productList: any[]) => {
    const productData = transformProductData(productList);
 
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(productData);
 
    // Header row with bold text
    ws['A1'] = { t: 's', v: 'Category', s: { font: { bold: true } } };
    ws['B1'] = { t: 's', v: 'Sub Category', s: { font: { bold: true } } };
    ws['C1'] = { t: 's', v: 'Measurement Type', s: { font: { bold: true } } };
    ws['D1'] = { t: 's', v: 'Name', s: { font: { bold: true } } };
    ws['E1'] = { t: 's', v: 'Unit Price', s: { font: { bold: true } } };
    ws['F1'] = { t: 's', v: 'GST %', s: { font: { bold: true } } };
    ws['G1'] = { t: 's', v: 'In Stock', s: { font: { bold: true } } };
 
    // Fill the sheet with data
    for (let r = 2; r <= productData.length + 1; r++) {
        const cellCategory = `A${r}`;
        const cellSubCategory = `B${r}`;
        const cellMeasurementType = `C${r}`;
        const cellName = `D${r}`;
        const cellUnitPrice = `E${r}`;
        const cellGST = `F${r}`;
        const cellInStock = `G${r}`;
 
        const formattedUnitPrice = `${productData[r - 2].UnitPrice.toFixed(2)}`;
        const formattedGST = `${productData[r - 2].GSTPercentage}%`;
        const formattedInStock = `${productData[r - 2].InStock}`;
 
        // Populate each row's columns
        ws[cellCategory] = { t: 's', v: productData[r - 2].Category };
        ws[cellSubCategory] = { t: 's', v: productData[r - 2].SubCategory };
        ws[cellMeasurementType] = { t: 's', v: productData[r - 2].MeasurementType };
        ws[cellName] = { t: 's', v: productData[r - 2].Name };
        ws[cellUnitPrice] = { t: 'n', v: formattedUnitPrice, z: '#,##0.00' };
        ws[cellGST] = { t: 's', v: formattedGST };
        ws[cellInStock] = { t: 's', v: formattedInStock };
    }
 
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'ProductListExport.xlsx');
};
 
const transformProductData = (productList: any[]) => {
    const flatData: any = [];
 
    productList?.forEach((product) => {
        flatData.push({
            'Category': product.categoryName,  
            'SubCategory': product.subCategoryName,  
            'MeasurementType': product.measurementTypeName,  
            'Name': product.name,  
            'UnitPrice': product.unitPrice,  
            'GSTPercentage': product.gst,  
            'InStock': product.inStock,  
        });
    });
 
    return flatData;
};
 
 